export default __webpack_public_path__ + "static/media/youtube-white.12ae875d.svg";